export default __webpack_public_path__ + "static/media/Nikosh.d3bab8cb.ttf";